/**
 * Chart colours for the lung/weather review, taken from the palette the climate views already use so the two
 * screens read as one system.
 *
 * One accent (indigo, the same hue as the page's primary) plus amber reserved strictly for the warning threshold.
 * State is encoded by form rather than by more hues - a filled marker means a real peak followed, a hollow one
 * means nothing did. Green would be the obvious third colour and it would be wrong here, since "the warning came
 * true" means an outbreak happened.
 */
export const lungWeatherColors = {
  /** indigo-500 — the series colour, matching the system's chart primary. */
  accent: '#6366f1',
  accentSoft: 'rgba(99, 102, 241, 0.12)',

  /** amber-500 — the warning threshold, and nothing else. */
  warning: '#f59e0b',
  warningSoft: 'rgba(245, 158, 11, 0.10)',

  /** gray-400 — axis ticks and recessive marks. */
  muted: '#9ca3af',

  /** gray-100 — gridlines. */
  grid: '#f3f4f6',

  /** gray-200 — hairline borders. */
  hairline: '#e5e7eb',

  /** gray-900 — the days treatments actually clustered. */
  ink: '#111827',

  surface: '#ffffff'
};
